const documentOptions = {
  CL: [
    { value: 'CHL2', label: 'Documento de identidad chileno nuevo' },
    { value: 'CHL1', label: 'Documento de identidad chileno antiguo' },
  ],
  PE: [
    { value: 'PER1', label: 'Documento de identidad peruano antiguo azul' },
    { value: 'PER2', label: 'Documento de identidad peruano blanco (con chip contact a la vista)' },
    { value: 'PER5', label: 'Documento de identidad peruano nuevo (con NFC, año 2020)' },
  ],
  AR: [
    { value: 'ARG1', label: 'Documento de identidad argentino antiguo' },
    { value: 'ARG2', label: 'Documento de identidad argentino nuevo' },
  ],
  MX: [
    { value: 'MEX1', label: 'Documento de identidad mexicano antiguo (IFE)' },
    { value: 'MEX2', label: 'Documento de identidad mexicano (INE)' },
    { value: 'MEX3', label: 'Documento de identidad mexicano nuevo (INE 2020)' },
  ],
}

export { documentOptions }
